import c from "lib/style/colorVar.scss";
import { styled } from "@mui/material";
import { MaterialDesignContent } from 'notistack';

export const StyledSnackbar = styled(MaterialDesignContent)(() => ({
  '&.notistack-MuiContent-info': {
    backgroundColor: c["brand1"],
  },
  '&.notistack-MuiContent-success': {
    backgroundColor: c["success"],
  },
  '&.notistack-MuiContent-warning': {
    backgroundColor: c["warning"],
  },
  '&.notistack-MuiContent-error': {
    backgroundColor: c["danger"],
  },
}));